import * as mapboxgl from 'mapbox-gl';
import { GeoJSONSource } from 'mapbox-gl';
import Mapbox from 'index.vue';
import { BaseFeatureLayer } from './baseFeatureLayer';
export class AreaLayer
{
    protected mapboxInstance: InstanceType<typeof Mapbox>;
    protected fillLayer: BaseFeatureLayer;
    protected outlinesLayer: BaseFeatureLayer;


    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        this.mapboxInstance = mapboxInstance;
        this.fillLayer = new BaseFeatureLayer(mapboxInstance, 'top', 'area-fill-layer', 'area-fill-source', 'fill', {}, {
            'fill-color': '#4CAF40',
            'fill-opacity': 0.6
        }, true);
        this.outlinesLayer = new BaseFeatureLayer(mapboxInstance, 'top', 'area-outlines-layer', 'area-outlines-source', 'line', {}, {
            'line-color': '#24714D',
            'line-width': 3
        });
    }
    
    public DataChanged = async () => {
        this.fillLayer.SetFeatures(this.mapboxInstance.area == null ? [] : this.mapboxInstance.area.featureCollection);
        this.outlinesLayer.SetFeatures(this.mapboxInstance.area == null ? [] : this.mapboxInstance.area.featureCollection);
    };
}   
